export default function MatchStatusBadge({ matched }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
        matched
          ? "bg-green-100 text-green-800"
          : "bg-gray-100 text-gray-600"
      }`}
    >
      {matched ? "Matched" : "Unmatched"}
    </span>
  );
}
